import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader
} from "../../store/actions";

class SidebarContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
          
        };
       
    }
    
    componentDidMount() {
        this.initMenu();
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
          
            if (this.props.type !== prevProps.type) {
                this.initMenu();
            }

        }
    }

    initMenu() {
            new MetisMenu("#side-menu");

            var matchingMenuItem = null;
            var ul = document.getElementById("side-menu");
            var items = ul.getElementsByTagName("a");
            for (var i = 0; i < items.length; ++i) {
                if (this.props.location.pathname === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }
            if (matchingMenuItem) {
                this.activateParentDropdown(matchingMenuItem);
            }
    }

    activateParentDropdown = item => {
        item.classList.add("active");
        const parent = item.parentElement;

        if (parent) {
            parent.classList.add("mm-active");
            const parent2 = parent.parentElement;

            if (parent2) {
                parent2.classList.add("mm-show");

                const parent3 = parent2.parentElement;

                if (parent3) {
                    parent3.classList.add("mm-active"); // li
                    parent3.childNodes[0].classList.add("mm-active"); //a
                    const parent4 = parent3.parentElement;
                    if (parent4) {
                        parent4.classList.add("mm-active");
                    }
                }
            }
            return false;
        }
        return false;
    };

    render() {
        return (
            <React.Fragment>
                 <div id="sidebar-menu">

                        <ul className="metismenu list-unstyled" id="side-menu">
                            <li className="menu-title">Menu</li>

                            <li>
                                <Link to="/dashboard" className="waves-effect">
                                    <i className="ri-dashboard-line"></i><span className="badge badge-pill badge-success float-right">3</span>
                                    <span className="ml-1">Dashboard</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/campinfo" className=" waves-effect">
                                    <i className="ri-table-2"></i>
                                    <span className="ml-1">Latest Stats</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/locationPoint" className=" waves-effect">
                                    <i className="ri-map-pin-5-line"></i>
                                    <span className="ml-1">Location Point</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className=" ri-building-2-line"></i>
                                    <span className="ml-1">Facilities</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li>
                                        <Link to="/facility-add" className=" waves-effect">
                                            <i className="ri-building-line"></i>
                                            <span className="ml-1">Add New Facility</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/facility-manager" className=" waves-effect">
                                            <i className=" ri-hotel-line"></i>
                                            <span className="ml-1">Facility Manager</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/facility-data-type" className=" waves-effect">
                                            <i className=" ri-hotel-line"></i>
                                            <span className="ml-1">Facility Data Types</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="ri-folder-shield-2-line"></i>
                                    <span className="ml-1">File Data</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li>
                                        <Link to="/datastore" className=" waves-effect">
                                            <i className="ri-file-cloud-line"></i>
                                            <span className="ml-1">Submit Data</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/fileUploadedInfo" className=" waves-effect">
                                            <i className="ri-file-shred-line"></i>
                                            <span className="ml-1">Uploaded File Info</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                             
                            
                            
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="ri-archive-drawer-line"></i>
                                    <span className="ml-1">Testimony</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li>
                                        <Link to="/testimony" className=" waves-effect">
                                            <i className="ri-edit-line"></i>
                                            <span className="ml-1">Registration</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/testimonyList" className=" waves-effect">
                                            <i className=" ri-timer-line"></i>
                                            <span className="ml-1">Pending Testimony</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/testimonyVerify" className=" waves-effect">
                                            <i className="ri-checkbox-multiple-line"></i>
                                            <span className="ml-1">Direct Testimony</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/testimonyManager" className=" waves-effect">
                                            <i className="ri-eye-line"></i>
                                            <span className="ml-1">Testimony Manager</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <Link to="/register-user" className="waves-effect">
                                    <i className="ri-edit-line"></i>
                                    <span className="ml-1">Register (Under Construction)</span>
                                </Link>
                            </li>
                            
                            <li>
                                <Link to="/admin" className=" waves-effect">
                                    <i className="ri-todo-line"></i>
                                    <span className="ml-1">Team Admin</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/faqs" className=" waves-effect">
                                    <i className="ri-questionnaire-line"></i>
                                    <span className="ml-1">FAQs</span>
                                </Link>
                            </li>

                        </ul>
                    </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return { ...state.Layout };
  };

export default withRouter(connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader
})((SidebarContent)));
